import React, { useContext } from "react";
import ApplicationContext from "../../../context/index";
import CallToAction from "../partials/cta";
import ErrorMessage from "../partials/error";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FieldLabel from "../../../components/label";
import SectionTitle from "../../../components/sectionTitle";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { BUTTON_CONFIRM_AND_PROCEED } from "../../../constants";
import { useStyles } from "../indexFormStyles";
import { withStyles } from "@mui/styles";

function BuyflowReviewDetailsForm({
  classes: { containerButton, contentScroller, gridLabel, main },
  checkboxes,
  declaration,
  errors,
  handleBack,
  handleChange,
  handleDownload,
  isFormSubmitted,
  modal,
  onSubmit,
}) {
  const { state, dispatch } = useContext(ApplicationContext);
  return (
    <Box className={main}>
      <form noValidate autoComplete="off" onSubmit={onSubmit}>
        <Box display="flex" justifyContent="center" m={2} mb={0} mt={3}>
          <SectionTitle title={"Review Details"} onClickHandler={handleBack} />
        </Box>

        <Box className={contentScroller}>
          <Box textAlign={"left"} mt={2}>
            {state.documents.map((item) => {
              return (
                <Box
                  key={item.title}
                  flexDirection={"column"}
                  display={"flex"}
                  m={0.5}
                  mb={2}
                  mt={2}
                >
                  <Grid container spacing={1} mt={1}>
                    <Grid item xs={6} className={gridLabel}>
                      <FieldLabel label={item.title} variant="caption" />
                    </Grid>
                    <Grid item xs={6} className={gridLabel}>
                      <Button
                        type={"button"}
                        size={"small"}
                        variant={"contained"}
                        color={"secondary"}
                        onClick={() => handleDownload(item.url, item.title)}
                      >
                        <Stack
                          direction="row"
                          gap={1}
                          display={"flex"}
                          justifyContent={"center"}
                          alignItems={"center"}
                        >
                          <FileDownloadIcon fontSize="small" />
                          <Typography variant="caption">Download</Typography>
                        </Stack>
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              );
            })}
          </Box>

          <Box className={containerButton}>
            <ErrorMessage errors={errors} modal={modal} />
            <Box textAlign={"left"} mt={1} mb={1} ml={0.5} mr={0.5}>
              {checkboxes.map((item, index) => {
                return (
                  <Box mt={2} key={`declaration-${index}`}>
                    <FormControlLabel
                      control={
                        <Box style={{ alignSelf: "start" }}>
                          <Checkbox
                            checked={declaration[item.value]}
                            onChange={handleChange}
                            name={item.value}
                            color="primary"
                          />
                        </Box>
                      }
                      label={
                        <Box mt={1}>
                          <Typography variant="caption">
                            {item.title}
                          </Typography>
                        </Box>
                      }
                      sx={{ marginRight: "0px" }}
                    />
                  </Box>
                );
              })}
            </Box>

            <Box>
              <CallToAction
                buttonType={"submit"}
                isFormSubmitted={false}
                text={BUTTON_CONFIRM_AND_PROCEED}
                isDisabled={isFormSubmitted || !declaration.agree}
              />
            </Box>
          </Box>
        </Box>
      </form>
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(
  BuyflowReviewDetailsForm
);
